import assign from 'lodash/assign';

import ClusterSettingConstants from './ClusterSettingConstants';

// @ts-ignore
import DispatchConstants from './DispatchConstants';
import ErrorConstants from './ErrorConstants';
import StringConstants from './StringConstants';
import ValueConstants from './ValueConstants';

const constants = assign(
  {},
  ClusterSettingConstants,
  DispatchConstants,
  ErrorConstants,
  StringConstants,
  ValueConstants,
);

export default constants;
